var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrowIconScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 24.3,
    viewBox: "0 0 160.2 24.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 327",
    d: "M77.742 23.788L.246 1.265C-.478 1.054-.7.736-.312.458A4.654 4.654 0 012.009 0H157a4.644 4.644 0 012.318.459c.385.277.164.6-.56.806L81.262 23.788a7.4 7.4 0 01-3.521 0",
    fill: "#535b80",
    stroke: "#535b80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrowIconScroll);
export default __webpack_public_path__ + "static/media/prevArrowIconScroll.83d3ccc213b28da3.svg";
export { ForwardRef as ReactComponent };